import SuccessIcon from './SuccessIcon';

export default SuccessIcon;
